export function newAccountToBasic(plan) {
  // Bit of a hack - if the user has signed up to a 'basic' account they aren't in Stripe and therefore their plan is returned as 'newAccount' in the backend
  if (plan === 'newAccount') {
    return 'basic';
  }
  return plan;
}

export function prettyOldPlanName(plan) {
  switch (plan) {
    case 'free_player':
      return 'basic (old)';
    case 'paid_player':
      return 'paid player';
    case 'coach_rec':
      return 'recreational';
    case 'coach_team':
      return 'team';
    case 'coach_club':
      return 'club';
    // no default
  }
  return plan;
}

export default function planName(plan) {
  return newAccountToBasic(prettyOldPlanName(plan));
}



// WEBPACK FOOTER //
// ./library/app/utils/planStringConversion.js